import { ApplicationEvents } from '../types/ApplicationEvent';

import { baseApi } from './baseApi';

export const applicationEventApi = baseApi
  .enhanceEndpoints({ addTagTypes: ['ApplicationEvents'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getApplicationEvents: builder.query<ApplicationEvents, void>({
        query: () => 'api/v6/careplan/application_events',
        providesTags: ['ApplicationEvents'],
      }),
    }),
    overrideExisting: false,
  });

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const {
  useGetApplicationEventsQuery,
  useLazyGetApplicationEventsQuery,
} = applicationEventApi;
